class HeaderMegaMenu extends HTMLElement {
  constructor() {
    super();

    this.navOpen = false;
  }

  connectedCallback() {
    this.details = this.querySelectorAll('.details');
    this.content = this.querySelectorAll('.content');

    this.addTransitionInitialise();

    this.onHover();
  }

  onHover = () => {
    this.details.forEach((item, index) => {
      if (!this.navOpen) {
        this.content[index].classList.add('tw-scale-y-90', 'tw-opacity-0', 'tw-origin-top');
      }

      item.addEventListener('mouseenter', () => {
        if (!this.navOpen) {
          this.removeTransition();

          this.navOpen = true;
        }

        this.makeVisible(index);
      });

      item.addEventListener('mouseleave', () => {
        this.makeInvisible(index);
      });
    });
  };

  makeVisible = (index) => {
    this.content[index].classList.remove('tw-invisible');
    this.content[index].classList.add('tw-visible');
  };

  makeInvisible = (index) => {
    this.content[index].classList.add('tw-invisible');
    this.content[index].classList.remove('tw-visible');
  };

  addTransitionInitialise = () => {
    this.addEventListener('mouseleave', () => {
      if (this.navOpen) {
        this.addTransition();

        this.navOpen = false;
      }
    });
  };

  removeTransition = () => {
    this.content.forEach((item) => {
      item.classList.remove('tw-scale-y-90');
      item.classList.remove('tw-opacity-0');
      item.classList.add('tw-scale-y-100');
      item.classList.add('tw-opacity-100');
    });
  };

  addTransition = () => {
    this.content.forEach((item) => {
      item.classList.remove('tw-scale-y-100');
      item.classList.remove('tw-opacity-100');
      item.classList.add('tw-scale-y-90');
      item.classList.add('tw-opacity-0');
    });
  };

  open() {
    this.content.forEach((item) => {
      item.classList.remove('tw-hidden');
    });
  }

  close() {
    this.content.forEach((item) => {
      item.classList.remove('tw-visible');
      item.classList.add('tw-hidden');
    });
  }
}

customElements.define('hover-mega-menu', HeaderMegaMenu);
